import { registerTicketView } from "@shared/components/tickets/ticketViewRegistry";
import { dataQualityTicketType } from "./constants";
import PMTicketView from "./components/PMTicketView.vue";

registerTicketView({
  twinTypePattern: dataQualityTicketType,
  component: PMTicketView,
});
